import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import type { Theme } from "@mui/material";
import type { ComponentProps } from "react";

import apexSvg from "./predictor-apex-icon.svg?react";
import { makeSvgIcon } from "./svg-icon";

const getMainPredictorColor = (theme: Theme) => theme.palette.predictor.main;

const GenericIcon = makeSvgIcon(AccountTreeOutlined, getMainPredictorColor);

const COMPONENT_MAP = {
  apex: makeSvgIcon(apexSvg, getMainPredictorColor),
  pioneer: makeSvgIcon(AccountTreeOutlined, getMainPredictorColor),
} as const;

export function PredictorIcon({
  type,
  ...props
}: ComponentProps<typeof GenericIcon> & {
  type?: keyof typeof COMPONENT_MAP;
}) {
  const Component = type ? COMPONENT_MAP[type] : GenericIcon;
  return <Component {...props} />;
}

export default PredictorIcon;
